document.addEventListener('DOMContentLoaded', function() {
  /* ==========================================================================
     1. Intersection Observer — fade-in sections
     ========================================================================== */
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, observerOptions);

  document.querySelectorAll('.shopify-section').forEach(section => {
    observer.observe(section);
  });

  /* ==========================================================================
     2. Header scroll effect
     ========================================================================== */
  const header = document.querySelector('header-component');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  /* ==========================================================================
     3. Product media — staggered fade-in for grid images
     ========================================================================== */
  const mediaItems = document.querySelectorAll('.product-media-container');
  if (mediaItems.length) {
    const mediaObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          // Stagger the reveal
          setTimeout(() => {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }, i * 80);
          mediaObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05 });

    mediaItems.forEach(item => {
      item.style.opacity = '0';
      item.style.transform = 'translateY(12px)';
      item.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      mediaObserver.observe(item);
    });
  }

  /* ==========================================================================
     4. PDP layout restructure — title above grid, three-column bottom
     ========================================================================== */
  (function() {
    const grid = document.querySelector('.product-information__grid');
    if (!grid) return;

    const details = grid.querySelector('.product-details');
    if (!details) return;

    // --- 4a. Move title above grid ---
    const titleEl = details.querySelector('h1');
    if (titleEl) {
      const titleClone = titleEl.cloneNode(true);
      const titleContainer = document.createElement('div');
      titleContainer.className = 'pdp-title-container';
      titleContainer.appendChild(titleClone);
      grid.parentNode.insertBefore(titleContainer, grid);
      titleEl.style.display = 'none';
    }

    // --- 4b. Find the price and move it below media, above variant picker ---
    const priceEl = details.querySelector('.price');
    const variantPicker = details.querySelector('.variant-picker');
    if (priceEl && variantPicker) {
      // If price is after the title, move it before variant picker
      variantPicker.parentNode.insertBefore(priceEl, variantPicker);
    }

    // --- 4c. Remove the original divider (between title and variant) ---
    // The divider_* in test-1 sits between title group and variant picker
    const divider = details.querySelector('[class*="divider"]');
    if (divider) divider.style.display = 'none';

    // --- 4d. Find description and compliance warnings ---
    const descriptionBlock = details.querySelector('.product__description, [class*="text_aEtTtq"]');
    const warnings = document.querySelector('.product-compliance-warnings');

    // Find the actual description content — look for the marker
    let descriptionElement = null;
    let descriptionText = '';

    if (descriptionBlock) {
      descriptionElement = descriptionBlock;
      descriptionText = descriptionBlock.innerHTML || '';
    } else {
      // Fallback: search for text blocks containing product description
      const allTextBlocks = details.querySelectorAll('[class*="text-"], .rte, .metafield-rich_text_field');
      allTextBlocks.forEach(function(block) {
        if (block.innerHTML && block.innerHTML.indexOf('===SPECS===') > -1) {
          descriptionElement = block;
          descriptionText = block.innerHTML;
        }
      });
    }

    if (descriptionElement && descriptionText) {
      // Mark as processed
      descriptionElement.classList.add('pdp-description-original');

      // --- Extract ===NAME=== ... ===NAME=== ---
      var namePattern = /===NAME===\s*([\s\S]*?)\s*===NAME===/;
      var nameMatch = descriptionText.match(namePattern);
      var productNameHtml = '';
      var remainingHtml = descriptionText;

      if (nameMatch) {
        productNameHtml = nameMatch[1].trim();
        remainingHtml = descriptionText.replace(namePattern, '').trim();
      }

      // --- Split remaining text at ===SPECS=== ---
      var specsMarker = '===SPECS===';
      var specsIndex = remainingHtml.indexOf(specsMarker);

      var introHtml = '';
      var specsHtml = '';

      if (specsIndex > -1) {
        introHtml = remainingHtml.substring(0, specsIndex).trim();
        specsHtml = remainingHtml.substring(specsIndex + specsMarker.length).trim();
      } else {
        // No marker — show full text in left column
        introHtml = remainingHtml;
        specsHtml = '';
      }

      // --- Create product name row (inserted after description, before bottom grid) ---
      var nameRow = null;
      if (productNameHtml) {
        nameRow = document.createElement('div');
        nameRow.className = 'pdp-product-name-row';
        nameRow.innerHTML = productNameHtml;
      }

      // --- Create bottom grid: two columns (intro + specs) ---
      var bottomGrid = document.createElement('div');
      bottomGrid.className = 'pdp-bottom-grid';

      // Column 1: Introduction
      var col1 = document.createElement('div');
      col1.className = 'pdp-bottom-col pdp-bottom-col--intro';
      col1.innerHTML = introHtml;

      // Column 2: Specifications
      var col2 = document.createElement('div');
      col2.className = 'pdp-bottom-col pdp-bottom-col--specs';
      if (specsHtml) {
        col2.innerHTML = specsHtml;
      }

      bottomGrid.appendChild(col1);
      bottomGrid.appendChild(col2);

      // --- Warning row — full width below the two columns ---
      if (warnings) {
        var warningRow = document.createElement('div');
        warningRow.className = 'pdp-warning-row';
        warningRow.appendChild(warnings.cloneNode(true));
        warnings.style.display = 'none';
        bottomGrid.appendChild(warningRow);
      }

      // --- Insert in correct order: description(hidden) → nameRow → bottomGrid ---
      if (descriptionElement.parentNode) {
        var parent = descriptionElement.parentNode;
        var ref = descriptionElement.nextSibling;

        if (nameRow) {
          parent.insertBefore(nameRow, ref);
          ref = nameRow.nextSibling;
        }
        parent.insertBefore(bottomGrid, ref);
      } else {
        details.appendChild(bottomGrid);
        if (nameRow) details.insertBefore(nameRow, bottomGrid);
      }
    }
  })();

  /* ==========================================================================
     5. Remove quick-add buttons from product cards
     ========================================================================== */
  (function() {
    // Remove quick-add-component elements
    document.querySelectorAll('quick-add-component, .quick-add').forEach(function(el) {
      el.remove();
    });
    // Remove any .add-to-cart-button inside product cards
    document.querySelectorAll('.product-card .add-to-cart-button, product-card .add-to-cart-button').forEach(function(el) {
      el.remove();
    });
  })();

  /* ==========================================================================
     6. Accordion — smooth open/close animation
     ========================================================================== */
  document.querySelectorAll('.accordion .details').forEach(details => {
    details.addEventListener('toggle', function() {
      if (this.open) {
        const content = this.querySelector('.details-content');
        if (content) {
          const startHeight = '0px';
          const endHeight = content.scrollHeight + 'px';
          content.style.overflow = 'hidden';
          content.animate(
            { height: [startHeight, endHeight] },
            { duration: 300, easing: 'ease' }
          );
        }
      }
    });
  });
});
